import React, {
  useState, useRef, isValidElement,
} from 'react'
import Popper from '@material-ui/core/Popper'
import Downshift from 'downshift'

import MenuList from '@material-ui/core/MenuList'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import Typography from '@material-ui/core/Typography'

import { IconButton } from '@workboard/wobo-ui'

/* todo: these to be replaced with wobo-ui icons */

import MoreVertIcon from '@material-ui/icons/MoreVert'

import EditIcon from '@material-ui/icons/CreateOutlined'
import PublishIcon from '@material-ui/icons/PublishOutlined'
import DeleteIcon from '@material-ui/icons/DeleteOutlined'
import LinkIcon from '@material-ui/icons/InsertLink'
import UnlinkIcon from '@material-ui/icons/LinkOff'
import PingIcon from '@material-ui/icons/NotificationsNoneOutlined'
import SyncIcon from '@material-ui/icons/Sync'
import UnsyncIcon from '@material-ui/icons/SyncDisabled'
import RedoIcon from '@material-ui/icons/Redo'
import PinfilledIcon from '../../../../vectors/pin-nofill.svg'
import PinfilledstarIcon from '../../../../vectors/pin-star-nofill.svg'
import CopycontentIcon from '../../images/copy-content.svg'
import MergeIcon from '@material-ui/icons/MergeType'
import EndseriesIcon from '@material-ui/icons/EventBusy';

import './ui.scss';

const icons = {
  DeleteIcon, EditIcon, LinkIcon, PublishIcon, PingIcon, UnlinkIcon, SyncIcon, UnsyncIcon, RedoIcon,
  PinfilledstarIcon, PinfilledIcon, CopycontentIcon, MergeIcon, EndseriesIcon
}

const renderMenu = (props) => {
  const {
    items, getMenuProps, getItemProps, highlightedIndex,
  } = props;
  return (
    <MenuList {...getMenuProps({}, {suppressRefError: true})}>
      {items && items.length && items.map((menuItem, index) => {
        return renderMenuItem({
          key: index, getItemProps, highlightedIndex, ...menuItem,
        })
      })}
    </MenuList>
  )
}

const renderIcon = (name) => {
  if (!name || name.length < 2) {
    return null
  }
  const iconComponentName = `${name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()}Icon`;

  if (!(iconComponentName in icons)) {
    return null
  }
  const IconComponent = icons[iconComponentName];
  return <ListItemIcon>
    <IconComponent fontSize="small" />
         </ListItemIcon>
}

/**
 * Render menu item component
 * @param params
 * icon - name of the icon or React.Element corresponding to an icon
 * name - the text to be shown next to the icon
 * noWrap - if true or not set, the text will not wrap, but instead will truncate with a text overflow ellipsis
 *
 */
const renderMenuItem = (props) => {
  const {
    key, noWrap, getItemProps, highlightedIndex, ...item
  } = props;
  return (
    <MenuItem
      key={key}
      {...getItemProps({ item, index: key, key })}
      selected={key === highlightedIndex}
      {...(typeof item.onClick === 'function' ? { onClick: item.onClick } : {})}
      {...(item.class ? { className: item.class } : {})}
    >
      {item.icon && typeof item.icon === 'string'
        && renderIcon(item.icon)}
      {'icon' in item && !item.icon && // use case: place holder for the icon if icon is not set
        <ListItemIcon></ListItemIcon>
      }
      {item.icon && isValidElement(item.icon)
        && (item.icon)}
      <Typography variant="inherit" noWrap={noWrap || true}>{item.name}</Typography>
    </MenuItem>
  )
}

function Kebab (props) {
  const {
    MenuComponent, items, onChange, ...rest
  } = props;

  const [anchorEl, setAnchorEl] = useState(null)
  const myRef = useRef(null);

  return (
    <>
      <Downshift
        onChange={(selection) => onChange(selection)}
        {...rest}
      >
        {({
          getToggleButtonProps,
          getItemProps,
          getMenuProps,
          getRootProps,
          highlightedIndex,
          isOpen,
        }) => (
          <div className={props.className} >

            <IconButton {...getToggleButtonProps()} ref={myRef}>
              <MoreVertIcon style={{ color: '#9e9e9e'}} />
            </IconButton>

            {isOpen && (
            <>
              <Popper
                className="m-kebab"
                onClick={(e) => e.stopPropagation()}
                anchorEl={myRef.current}
                open
                // disablePortal
              >

                {MenuComponent
            && <MenuComponent />}
                {!MenuComponent && items
            && renderMenu(
              {
                items, getMenuProps, getItemProps, highlightedIndex,
              },
            )}

              </Popper>

            </>
            )}
          </div>
        )}
      </Downshift>
    </>
  );
}

export default Kebab;
